/* app/js/src/components/outpost/outpost.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  background-color: rgb(235, 240, 244);
  overflow: hidden;
}
.menu {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
  height: 54px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  text-align: center;
}
.menu ichannel-link {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 110px;
  padding: 17px 0;
  gap: 6px;
  flex-shrink: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.menu ichannel-link:hover {
  background: rgb(45, 187, 252);
  cursor: pointer;
}
.menu ichannel-link:hover ::ng-deep a {
  color: #ffffff;
}
.menu ichannel-link.active,
.menu ichannel-link:has(::ng-deep a.active) {
  background: rgb(45, 187, 252);
}
.menu ichannel-link ::ng-deep a {
  color: rgba(0, 0, 0, 0.35);
  height: 20px;
  align-self: stretch;
  margin: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: uppercase;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.menu ichannel-link ::ng-deep a.active {
  color: #ffffff;
}
/*# sourceMappingURL=outpost.component.css.map */
